import React from 'react'
import { Tooltip, TooltipProps } from './tooltip'
import classNames from 'classnames'
import './tooltipWrapper.scss'

interface TooltipWrapperProps extends TooltipProps {
    children?: React.ReactNode
    className?: string
}

export const TooltipWrapper: React.FC<TooltipWrapperProps> = ({ children, className, ...tooltipProps }) => {
    return (
        <div className={classNames(className, 'tooltip-wrapper')}>
            {children}
            <Tooltip {...tooltipProps} />
        </div>
    )
}
